import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { getCurrentInstance } from "@vue/composition-api";

export function useCrisisFormStatus(crisisFormData) {
  const vm = getCurrentInstance().proxy;
  const owner = crisisFormData?.owner || {};

  //COMPOSABLES
  const { t } = useI18nUtils();

  //METHODS
  const formatDate = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      return d.toLocaleString();
    } catch {
      return iso;
    }
  }

  const formatStatus = (lastStatus) => {
    const name = (lastStatus) ? lastStatus.status.description : 'in_progress';
    const raw = String(name || "");
    const norm = raw
      .trim()
      .toLowerCase()
      .replace(/[-\s]+/g, "_");
    const aliases = { canceled: "cancelled" };
    const canonical = aliases[norm] || norm;
    const tryKeys = [
      `procedure_states.${canonical}`,
      `procedure_states.value.${canonical}`,
    ];
    for (const k of tryKeys) {
      const v = vm.$t ? vm.$t(k) : k;
      if (typeof v === "string" && v !== k) return v;
    }
    return raw;
  };

  const formatUser = (s) => {
    const { name:nameStatus } = s.status;
    const historicalUser      = (statusesByValidator.includes(nameStatus)) ? s.user_validation : s.user;
    const name                = (historicalUser) ? historicalUser.user : '-';
    const email               = (historicalUser) ? historicalUser.email : '-';

    return [name, email].filter(Boolean).join(' | ');
  }

  const getStatusLabel = (status) => {
    if (!status) return "-";

    return t(`operational_security.evaluation.status.${status}`);
  }

  const getStatusVariant = (status) => {
    if (!status) return "primary";

    const statusVariants = {
      in_progress: "primary",
      pending: "warning",
      review: "info",
      completed: "success",
      rejected: "danger",
      reopened: "warning",
      approved: "success"
    };

    return statusVariants[status] || "secondary";
  }

  const getUserEmail = (s) => {
    const { description:nameStatus } = s.status;

    switch (nameStatus) {
      case 'approved':
        return s.user_validation.email;
      case 'rejected':
        return s.user.email;
      case 'review':
        return s.user_validation.email;
      default:
        return s.user_validation?.email || owner.email || '-';
    }
  }

  const getUserName = (s) => {
    const { description:nameStatus } = s.status;

    switch (nameStatus) {
      case 'approved':
        return s.user_validation.user;
      case 'rejected':
        return s.user.user;
      case 'review':
        return s.user_validation.user;
      default:
        return s.user_validation?.user || owner?.user || '-';
    }
  }

  const statusesByValidator = ['approved','canceled','rejected','review'];

  return {
    formatDate,
    formatStatus,
    formatUser,
    getStatusLabel,
    getStatusVariant,
    getUserEmail,
    getUserName
  }

}
